export default __webpack_public_path__ + "static/assets/med_pill_square_out_L0_solid_x_01_f_mask.6a7683c4.png";